import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Check, Sparkles, LogIn, X } from 'lucide-react';
import Button from './ui/Button';

const AccessModal = ({
  isOpen,
  onClose,
  title = 'Acesso necessário',
  message = 'Você precisa fazer login para continuar',
  redirectTo = '/',
}) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate('/login');
  };

  const handleRegister = () => {
    onClose();
    navigate(`/register?redirect=${encodeURIComponent(redirectTo)}`);
  };

  if (!isOpen) return null;

  const perks = [
    'Acesso completo à plataforma',
    'Compra de tokens',
    'Geração de imagens com IA',
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-zinc-900 p-6 shadow-2xl">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-zinc-500 transition-colors hover:text-zinc-300"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-rose-500/15">
            <Lock className="h-6 w-6 text-rose-400" />
          </div>
          <h2 className="text-xl font-semibold text-white">{title}</h2>
          <p className="mt-1.5 text-sm text-zinc-400">{message}</p>
        </div>

        <ul className="mb-6 space-y-2.5">
          {perks.map((perk) => (
            <li key={perk} className="flex items-center gap-3 text-sm text-zinc-300">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500/15">
                <Check className="h-3 w-3 text-emerald-400" />
              </span>
              {perk}
            </li>
          ))}
        </ul>

        <div className="space-y-2.5">
          <Button onClick={handleRegister} icon={Sparkles} fullWidth size="lg">
            Criar conta gratuita
          </Button>
          <Button onClick={handleLogin} icon={LogIn} variant="secondary" fullWidth size="lg">
            Fazer login
          </Button>
          <Button onClick={onClose} variant="ghost" fullWidth size="sm">
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccessModal;
